import React from 'react';
import { Box, Text, Button, Icon } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { ApolloQueryResult } from '@apollo/client';

interface Props {
  children: React.ReactChild;
  refetch: (variables?: Record<string, any> | undefined) => Promise<ApolloQueryResult<any>>;
}
export function ErrorRetry({ children, refetch }: Props) {
  return (
    <Box
      alignItems={{ sm: 'center' }}
      justifyContent={{ sm: 'center' }}
      flexGrow={{ sm: 1 }}
      flexDirection={{ sm: 'column' }}
      p={{ sm: '500' }}
    >
      <Box pb={{ sm: '500' }}>
        <Text>{children}</Text>
      </Box>
      <Button onClick={() => refetch()}>
        <Box mr={{ sm: '400' }}>
          <Icon icon="undo" />
        </Box>
        <Trans> Retry</Trans>
      </Button>
    </Box>
  );
}
